import { useNavigate } from 'react-router-dom';
import { useAuth, ROLE_LABELS } from '../contexts/MemberAuthContext';
import FeedbackButton from './FeedbackButton';
import Icon from './Icon';

export default function AppHeader({ subtitle, showBack = true }) {
  const navigate = useNavigate();
  const { member, logout } = useAuth();

  const handleLogout = async () => { await logout(); navigate('/login'); };

  const initials = member
    ? (`${member.first_name?.[0] || ''}${member.last_name?.[0] || ''}`.toUpperCase() || '?')
    : '';

  return (
    <div className="header">
      <div className="brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img src="/logo.svg" width="38" height="38" alt="TEČČKa" />
        <div>
          <div className="header-title">TEČČKa</div>
          {subtitle && <div className="header-subtitle">{subtitle}</div>}
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        {member && (
          <>
            <div className="identity" onClick={() => navigate('/nastaveni')} title="Nastavení"
              style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
              <div style={{ textAlign: 'right', lineHeight: 1.25 }} className="hide-mobile">
                <div style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--text)' }}>{member.first_name} {member.last_name}</div>
                <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{ROLE_LABELS[member.role] || member.role}</div>
              </div>
              <div className="avatar">{initials}</div>
            </div>
            <span style={{ width: 1, height: 28, background: 'var(--border)' }} className="hide-mobile" />
          </>
        )}
        <button className="icon-btn icon-btn-accent" onClick={() => navigate('/sken')} title="Skenovat QR">
          <Icon name="qr" size={15} />
          <span className="hide-mobile">Skenovat</span>
        </button>
        {showBack && (
          <button className="icon-btn" onClick={() => navigate('/')}>
            <Icon name="home" size={15} />
            <span className="hide-mobile">Domů</span>
          </button>
        )}
        <FeedbackButton variant="header" />
        <button className="icon-btn" onClick={handleLogout}>
          <Icon name="logout" size={15} />
          <span className="hide-mobile">Odhlásit</span>
        </button>
      </div>
    </div>
  );
}
